exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Screen_Image {\n}\n.Screen_Highlight {\n  display: none;\n}\n.Screen_Highlight_Fill {\n  stroke: red;\n  stroke-width: 2;\n  fill: red;\n  fill-opacity: 0.25;\n}\n.Screen_Highlight_Outline {\n  stroke: #fff;\n  stroke-width: 2;\n  fill: none;\n}\n.Screen_Highlight_Label {\n  font-family: sans-serif;\n  font-weight: bold;\n  font-size: 36px;\n  stroke: #fff;\n  stroke-width: 1;\n  fill: red;\n}\n", ""]);

// exports
